import { FC } from 'react';
import { useTheme } from 'styled-components/native';

import IconDiscovery from '../../../assets/svg/IconDiscovery';
import IconFilter from '../../../assets/svg/IconFilter';
import IconSearch from '../../../assets/svg/IconSearch';
import { useTranslation } from '../../../i18n';
import { S } from './styles';

type Props = {
  hasFilter: boolean;
  isFuzzySearch: boolean;
};

export const NotFoundSubtitle = () => {
  const { t } = useTranslation();
  const { palette } = useTheme();

  return (
    <S.SubtitleContainer>
      <IconFilter
        size={13}
        fillColor={palette.neutralDark}
        id={`icon-filter-${Math.random().toString()}`}
      />
      <S.Subtitle testID="filterNotFoundSubtitle">
        {t('filter-not-found-subtitle')}
      </S.Subtitle>
    </S.SubtitleContainer>
  );
};

const EmptyResultHeader: FC<Props> = ({ hasFilter, isFuzzySearch }) => {
  const { t } = useTranslation();
  const { palette } = useTheme();

  return (
    <>
      <S.EmptyLayout>
        <S.EmptyResultImage source={require('../assets/empty_search.png')} />
        <S.EmptyResultTitle>{t('SearchNotFoundTitle')}</S.EmptyResultTitle>
        <S.EmptyResultSubtitle>
          {hasFilter ? (
            <NotFoundSubtitle />
          ) : (
            <S.SearchNotFoundSubTitleContainer>
              <IconSearch size={14} fillColor={palette.warrior} />
              <S.SearchNotFoundSubTitle testID="SearchNotFoundSubTitle">
                {t('SearchNotFoundSubTitle')}
              </S.SearchNotFoundSubTitle>
            </S.SearchNotFoundSubTitleContainer>
          )}
        </S.EmptyResultSubtitle>
      </S.EmptyLayout>
      <S.ListTitleField>
        {isFuzzySearch ? (
          <IconSearch
            fillColor={palette.warrior}
            // @ts-ignore for test
            testID="ListTitle-IconSearch"
          />
        ) : (
          // @ts-ignore for test
          <IconDiscovery testID="ListTitle-IconDiscovery" />
        )}
        <S.ListTitle>
          {t(isFuzzySearch ? 'fuzzy-search-discovery' : 'search-discovery')}
        </S.ListTitle>
      </S.ListTitleField>
    </>
  );
};

export default EmptyResultHeader;
